import styled, { createGlobalStyle, css, keyframes } from 'styled-components';

import { DodConnectionStatus } from './Dod.types';

type ConnectionDotProps = {
  $status: DodConnectionStatus;
};

const pulseAnimation = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(6, 211, 147, 0.4); }
  70% { box-shadow: 0 0 0 6px rgba(6, 211, 147, 0); }
  100% { box-shadow: 0 0 0 0 rgba(6, 211, 147, 0); }
`;

export const ConnectionDot = styled.div<ConnectionDotProps>(
  ({ theme: { palette }, $status }) => css`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${$status === 'connected'
      ? palette.chart.ok
      : $status === 'reconnecting'
      ? palette.chart.warn
      : palette.chart.bad};
    display: inline-block;
    margin-right: 8px;
    ${$status === 'connected' &&
    css`
      animation: ${pulseAnimation} 2s ease-in-out infinite;
    `}
  `,
);

export const ReconnectBanner = styled.div(
  ({ theme: { palette } }) => css`
    background-color: #fff4e0;
    color: ${palette.chart.warn};
    padding: 8px 16px;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    margin-bottom: 12px;
    border: 1px solid ${palette.chart.warn};
  `,
);

export const ConnectionStatus = styled.div(
  ({ theme: { palette } }) => css`
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    color: ${palette.grey[600]};
    padding: 4px 10px;
    border-radius: 16px;
    background-color: ${palette.grey[200]};
  `,
);

/* -- v2 shell -- */

export const StickyToolbar = styled.div(
  ({ theme: { palette } }) => css`
    position: sticky;
    top: 0;
    /* Above the charts' SVG only; the details panel is rendered by PageLayout beside the content. */
    z-index: 1;
    background-color: ${palette.common.white};
    margin-bottom: 16px;
  `,
);

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 24px;
`;

/**
 * The x-charts tooltip paints itself with `palette.background.paper`, which the shared theme sets
 * to the sidebar navy (#071E34) - every chart tooltip in the monitor came out white-on-black. The
 * tooltip renders in a portal under <body>, so a chart-level `sx` cannot reach it; this global rule
 * is mounted with the monitor page only.
 */
export const ChartTooltipStyle = createGlobalStyle(
  ({ theme: { palette } }) => css`
    .MuiChartsTooltip-paper {
      background-color: ${palette.common.white} !important;
      color: ${palette.text.primary} !important;
      border: 1px solid ${palette.grey[300]};
      box-shadow: 0 4px 16px rgba(7, 30, 52, 0.12);
    }

    .MuiChartsTooltip-mark {
      border-color: ${palette.common.white} !important;
    }

    .MuiChartsTooltip-cell,
    .MuiChartsTooltip-labelCell,
    .MuiChartsTooltip-valueCell {
      color: ${palette.text.primary} !important;
    }
  `,
);
